<template>
	<svg
		width="44"
		height="24"
		viewBox="0 0 44 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M43.4313 3.42483L23.4254 23.4238C23.043 23.7934 22.5319 24 22 24C21.4681 24 20.957 23.7934 20.5746 23.4238L0.568722 3.42483C0.297324 3.13567 0.113367 2.77561 0.0381334 2.3863C-0.0371 1.99699 -0.000535421 1.59435 0.143598 1.22494C0.296646 0.860961 0.554048 0.550409 0.883364 0.332424C1.21268 0.114439 1.59917 -0.00122534 1.99414 9.78968e-06H42.0059C42.4008 -0.00122534 42.7873 0.114439 43.1166 0.332424C43.446 0.550409 43.7034 0.860961 43.8564 1.22494C44.0005 1.59435 44.0371 1.99699 43.9619 2.3863C43.8866 2.77561 43.7027 3.13567 43.4313 3.42483Z"
		/>
	</svg>
</template>

<script>
export default {
	name: "Caret",
};
</script>
